/**
 * Sprint 4F2.4 — className-pari condivisi tra le card di scheda Vendita.
 *
 * Strategia: invece di duplicare le classi Tailwind in ogni componente
 * (Garanzie/Passaggio/...), centralizziamo i pattern visivi qui.
 * Modificare una costante = aggiornare TUTTE le card che la usano.
 *
 * Estratti da GaranzieSection.jsx (referente visivo).
 */

// Header colonna tabella (es. "PROVIDER", "DURATA", "ACQUISTO", "VENDITA")
export const COL_HEADER_LEFT = "text-left py-1";
export const COL_HEADER_CENTER = "text-center py-1";
export const COL_HEADER_RIGHT_AMBER = "text-right py-1 text-amber-700";
export const COL_HEADER_RIGHT_BLUE = "text-right py-1 text-blue-700";

// Wrapper riga thead (font-size + casing comune)
export const THEAD_WRAPPER = "text-[11px] uppercase text-slate-500 border-b";

// Cella dati (corpo riga)
export const CELL_TEXT_DEFAULT = "py-1.5 text-[12px]";
// Provider name (font normale, non monospace)
export const VALORE_TESTO_DEFAULT = "text-slate-700";
// Cella moneta acquisto / vendita (border-l verticale sottile + colore)
export const CELL_MONEY_ACQUISTO = "py-1.5 text-right font-mono text-amber-700 border-l-2 border-amber-200";
export const CELL_MONEY_VENDITA = "py-1.5 text-right font-mono text-blue-700 border-l-2 border-blue-200";

// Sprint UI-PREV — larghezze fisse colonne ACQUISTO e VENDITA per allineamento
// verticale tra TUTTE le card della scheda Preventivi/Vendite (Servizi, Accessori,
// Garanzie, Passaggio, CVT, Sconti). Ancorate a destra: le colonne di sinistra
// (Descrizione/Provider/Agenzia/...) assorbono la differenza.
export const COL_WIDTH_ACQUISTO = "w-[120px]";
export const COL_WIDTH_VENDITA = "w-[120px]";

// Bottoni icone azioni (matita / cestino) — usati in <td> dell'ultima colonna
export const CELL_AZIONI = "py-1.5 text-right";
export const ICON_BTN_EDIT = "text-slate-400 hover:text-blue-600 p-0.5";
export const ICON_BTN_DELETE = "text-slate-400 hover:text-rose-600 p-0.5";

// Sprint 4I1.A.1 — Warning banner per azioni critiche (modifica record di sistema, ecc.)
// Stile riusabile in modal e card per evidenziare cambiamenti strutturali.
export const WARNING_BANNER_CN =
  "flex items-start gap-2 bg-amber-50 border border-amber-300 text-amber-900 px-3 py-2 rounded-md text-[12px] leading-snug";
